module.exports = __webpack_public_path__ + "img/20.11e0f3be.jpg";